import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Briefcase, RefreshCw, Clock, Zap, MapPin} from 'lucide-react'

const audiences = [
  { icon: Briefcase, text: "Profissionais que precisam do inglês para crescer na carreira", color: "#0E8EA0" },
  { icon: RefreshCw, text: "Pessoas que já tentaram aprender inglês e não obtiveram sucesso", color: "#B038B2" },
  { icon: Clock, text: "Estudantes e adultos com rotina corrida", color: "#6CC4C4" },
  { icon: Zap, text: "Pessoas que buscam flexibilidade e autonomia no aprendizado", color: "#F5C542" },
  { icon: MapPin, text: "Quem deseja aprender inglês sem depender de salas presenciais ou horários fixos", color: "#0E8EA0" },
]

export default function AudienceSection() {
  const { ref, isVisible } = useScrollReveal()

  return (
    <section id="para-quem" className="py-20 md:py-28 bg-gray-50">
      <div ref={ref} className="max-w-7xl mx-auto px-5">
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Para quem é a <span style={{ color: "#B038B2" }}>English Work</span>
          </h2>
          <div className="w-20 h-1 rounded-full mx-auto" style={{ backgroundColor: "#0E8EA0" }} />
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {audiences.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-5 bg-white rounded-xl px-6 py-5 border-l-4 hover:shadow-lg transition-all duration-500 ${
                isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
              }`}
              style={{
                borderLeftColor: item.color,
                transitionDelay: isVisible ? `${(i + 1) * 100}ms` : "0ms",
              }}
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${item.color}15` }}
              >
                <item.icon size={22} style={{ color: item.color }} />
              </div>
              <p className="text-gray-700 text-base font-semibold">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
